// 获取地址栏
export function _getQueryId(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return '';
}
export function _getParames(name) {
  var after = window.location.hash.split('?')[1];
  if (after) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = after.match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
  }
}
